module.exports = __webpack_public_path__ + "img/2-5-1.c6f00505.png";